import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// PrimeNG Modules
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { SelectModule } from 'primeng/select';
import { CheckboxModule } from 'primeng/checkbox';
import { BadgeModule } from 'primeng/badge';
import { TooltipModule } from 'primeng/tooltip';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { DrawerModule } from 'primeng/drawer';
import { PanelModule } from 'primeng/panel';
import { TagModule } from 'primeng/tag';
import { ProgressBarModule } from 'primeng/progressbar';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PopoverModule } from 'primeng/popover';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { DatePickerModule } from 'primeng/datepicker';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputNumberModule } from 'primeng/inputnumber';
import { DividerModule } from 'primeng/divider';
import { TabsModule } from 'primeng/tabs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TextareaModule } from 'primeng/textarea';
import { FileUploadModule } from 'primeng/fileupload';
import { EditorModule } from 'primeng/editor';

// NgxPermissions
import { NgxPermissionsModule } from 'ngx-permissions';

// Components
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { BookingViewDialogComponent } from './components/booking-view-dialog/booking-view-dialog.component';
import { ClockComponent } from './components/clock/clock.component';
import { CardComponent } from './components/card/card.component';

const PRIMENG_MODULES = [
    CardModule,
    ButtonModule,
    InputTextModule,
    TableModule,
    DialogModule,
    ToastModule,
    SelectModule,
    CheckboxModule,
    BadgeModule,
    TooltipModule,
    AvatarModule,
    MenuModule,
    DrawerModule,
    PanelModule,
    TagModule,
    ProgressBarModule,
    PaginatorModule,
    ProgressSpinnerModule,
    ConfirmDialogModule,
    PopoverModule,
    DynamicDialogModule,
    MultiSelectModule,
    DatePickerModule,
    CheckboxModule,
    AutoCompleteModule,
    DividerModule,
    InputNumberModule,
    TextareaModule,
    TabsModule,
    FileUploadModule,
    EditorModule,
    NgbModule
];

@NgModule({
    declarations: [
        ConfirmDialogComponent,
        PaginationComponent,
        BookingViewDialogComponent,
        ClockComponent,
        CardComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ...PRIMENG_MODULES,
        NgxPermissionsModule.forChild()
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ...PRIMENG_MODULES,
        NgxPermissionsModule,
        ConfirmDialogComponent,
        PaginationComponent,
        BookingViewDialogComponent,
        ClockComponent,
        CardComponent
    ]
})
export class SharedModule { }
